export const SETTINGS = '/settings';
export const EXPERIENCE = '/experience';
export const ORDER_HISTORY = '/order-history';
export const PAYMENT_LINK = '/payments/:bookingRequestId';
